/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import { AdWaypointPassengersWaypointFragmentDoc } from '../../../../ad-passenger-list/src/lib/AdWaypointPassengers/AdWaypointPassengers.hook'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
export type AdAlertListCardVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  fccHandledByOperator: {
    __typename?: 'BackofficeUser'
    firstName: string
    lastName: string
  } | null
  fccCurrentAdAlerts: {
    __typename?: 'FccAdAlerts'
    alerts: Array<{
      __typename: 'FccAdAlert'
      id: string
      type: Types.FccAdAlertType
      createdAt: string
    }>
  } | null
  fccUpcomingWaypoints: Array<{
    __typename?: 'FccWaypoint'
    id: string
    fccStop: {
      __typename?: 'FccStop'
      id: string | null
      names: Partial<Record<'de' | 'en' | 'no', string>>
    } | null
    stopWithServiceArea: {
      __typename?: 'Stop'
      id: string
      serviceArea: { __typename?: 'ServiceArea'; id: string }
    } | null
    actions: Array<
      | {
          __typename: 'FccWaypointDeliveryAction'
          id: string
          estimatedAt: string
          pickedUpAt: string | null
          trip: { __typename?: 'Trip'; id: string } | null
          customer: {
            __typename?: 'Customer'
            firstName: string | null
            lastName: string | null
            extendedWalkingTime: boolean
            visualImpairment: boolean | null
          } | null
          ridePassengerInfo: {
            __typename?: 'FccRidePassengerInfo'
            customerId: string | null
            displayName: string | null
            boardingRequirements: {
              __typename?: 'FccBoardingRequirements'
              headCount: number
              childSeat: boolean
              wheelchair: boolean
            } | null
            impairments: {
              __typename?: 'FccImpairments'
              visual: boolean
            } | null
          } | null
        }
      | { __typename?: 'FccWaypointHubReturnAction' }
      | {
          __typename: 'FccWaypointPickupAction'
          id: string
          estimatedAt: string
          pickedUpAt: string | null
          adPassengerAuthenticationState: Types.FccPassengerAuthenticationState | null
          notShownUpAt: string | null
          tripIsCancelled: boolean | null
          trip: { __typename?: 'Trip'; id: string } | null
          customer: {
            __typename?: 'Customer'
            firstName: string | null
            lastName: string | null
            extendedWalkingTime: boolean
            visualImpairment: boolean | null
          } | null
          ridePassengerInfo: {
            __typename?: 'FccRidePassengerInfo'
            customerId: string | null
            displayName: string | null
            boardingRequirements: {
              __typename?: 'FccBoardingRequirements'
              headCount: number
              childSeat: boolean
              wheelchair: boolean
            } | null
            impairments: {
              __typename?: 'FccImpairments'
              visual: boolean
            } | null
          } | null
        }
      | { __typename?: 'FccWaypointReallocationAction' }
    >
  }> | null
}

export type AdAlertListCardAlertFragment = {
  __typename: 'FccAdAlert'
  id: string
  type: Types.FccAdAlertType
  createdAt: string
}

export const AdAlertListCardAlertFragmentDoc = gql`
    fragment AdAlertListCardAlert on FccAdAlert {
  __typename
  id
  type
  createdAt
}
    `
export const AdAlertListCardVehicleFragmentDoc = gql`
    fragment AdAlertListCardVehicle on Vehicle {
  id
  fccHandledByOperator {
    firstName
    lastName
  }
  fccCurrentAdAlerts {
    alerts {
      ...AdAlertListCardAlert
    }
  }
  fccUpcomingWaypoints {
    ...AdWaypointPassengersWaypoint
  }
}
    ${AdAlertListCardAlertFragmentDoc}
${AdWaypointPassengersWaypointFragmentDoc}`
